import axios from "axios";

export const IMPERSONATION_MISSING_TICKET_ERROR =
  "Линкът не съдържа данни за вход. Генерирайте нов от админ панела.";

export const IMPERSONATION_FALLBACK_ERROR =
  "Входът в профила не беше успешен. Генерирайте нов линк от админ панела.";

/**
 * The one-time ticket from the admin panel's link. It travels in the fragment (after "#"),
 * which the browser never sends to the server hosting the app.
 */
export const readImpersonationTicket = (hash: string): string | null => {
  const ticket = hash.replace(/^#/, "").trim();
  return ticket ? ticket : null;
};

/** The user's start page, opened in the studio the admin panel picked for the session. */
export const buildImpersonationLandingPath = (
  path: string,
  studioId?: number | null,
): string => {
  if (!studioId) {
    return path;
  }

  const separator = path.includes("?") ? "&" : "?";
  return `${path}${separator}selectedStudio=${studioId}`;
};

export const getImpersonationErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    const message = (error.response?.data as { message?: unknown } | undefined)?.message;
    if (typeof message === "string" && message) {
      return message;
    }
  }

  return IMPERSONATION_FALLBACK_ERROR;
};
